import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import KnowledgeWordsBackground from './KnowledgeWordsBackground';

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
            delayChildren: 0.2
        }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, ease: "easeOut" }
    }
};

export default function HeroSection() {
    return (
        <section className="relative h-screen min-h-[600px] w-full overflow-hidden bg-primary-950 text-white">
            {/* Scrolling Knowledge Words Background */}
            <KnowledgeWordsBackground />


            {/* Content */}
            <div className="container mx-auto px-6 relative z-10 h-full flex items-center">
                <div className="max-w-3xl relative z-10 bg-primary-950/60 backdrop-blur-sm p-8 md:p-12 rounded-2xl border border-white/10 shadow-2xl">
                    <motion.div
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        <motion.div variants={itemVariants}>
                            <span className="inline-block px-4 py-2 rounded-full bg-primary-900/80 backdrop-blur-md border border-primary-700/50 text-accent-400 font-medium mb-6 shadow-xl">
                                Saison 2025-2026
                            </span>
                        </motion.div>

                        <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl font-serif font-bold leading-tight mb-6 drop-shadow-2xl">
                            Apprendre à <br className="hidden md:block" />
                            <span className="text-white">
                                Tout Âge
                            </span>
                        </motion.h1>

                        <motion.p variants={itemVariants} className="text-xl text-primary-100 mb-10 leading-relaxed max-w-lg drop-shadow-md">
                            Découvrez des conférences passionnantes, des excursions culturelles et une communauté dynamique avec l'Université de Tous Âges Nord-Luxembourg (Barvaux-sur-Ourthe).
                        </motion.p>

                        <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-4">
                            <Link
                                to="/agenda"
                                className="group relative px-8 py-4 bg-accent-500 hover:bg-accent-400 text-primary-950 font-bold rounded-lg transition-all flex items-center justify-center gap-2 overflow-hidden shadow-lg shadow-accent-500/20"
                            >
                                <span className="relative z-10">Découvrir l'Agenda</span>
                                <ArrowRight className="relative z-10 transition-transform group-hover:translate-x-1" size={20} />
                            </Link>

                            <Link
                                to="/a-propos"
                                className="px-8 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white font-medium rounded-lg transition-colors flex items-center justify-center border border-white/20 hover:border-white/40"
                            >
                                En savoir plus
                            </Link>
                        </motion.div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
